export const selectCloudUsageData = (state) => state.cloudUsage.data;
export const selectCloudUsageDataDetail = (state) => state.cloudUsage.dataDetail;
export const selectCloudUsageIsLoading = (state) => state.cloudUsage.isLoading;
export const selectCloudUsageError = (state) => state.cloudUsage.error;
export const selectCloudUsageFilters = (state) => state.cloudUsage.filters;
export const selectCloudUsageExportIsLoading = (state) => state.cloudUsage.exportIsLoading;
export const selectSelectedWorkspaceId = (state) => state.cloudUsage.selectedWorkspaceId;
